module.exports = __webpack_public_path__ + "static/media/Location_Book-Page15.68063a72.png";